import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';

const Row = ({ value }) => (
  <TableRow>
    <TableCell>{value}</TableCell>
  </TableRow>
)

export default Row;